import * as ko from "knockout";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-upload";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import GenericListTab from "./../../factories/generic-list-tab";
import guid from "./../../factories/guid";
import TabPage from "./../../factories/tab-page";
import BaoRouter from "./../../services/bao-router";
import Bao from "./../../services/bao-service";
import { WorkItemAttachmentConstants } from "./../constants/work-item-attachment-constants"
import WorkItem from "../work-item";

/**
 * ViewModel for WorkItemAttachment
 */
class WorkItemAttachmentTab extends GenericListTab {

    // #region Constructor

    /** 
     *Constructor
     */
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);

        this.WorkItem = parent;

        this.Models.subscribe(() => {
            this.Selection([]);
        });

        this._subs.push(this.ToolbarButtons.subscribe(() => {
            this.ToggleToolbarButtons();
        }));

        this._subs.push(this.Selection.subscribe(() => {
             this.ToggleToolbarButtons();
        }));
    }

    //  #endregion

    // #region Properties

    /**
     * Controller Url 
     */
    ControllerUrl = "WorkItemAttachment";

    /**
     * Knockout Subscription array
     */
    _subs: KnockoutSubscription[] = [];

    /** 
     *  message Cancel
     */
    _msgCancel = Bao.Session.GetMessage("msgCancel");

    /** 
     *  message OK
     */ 
    _msgOk = Bao.Session.GetMessage("msgOk");

    /**
     * Work Item Object
     */
    WorkItem: any;

    // Bao object to access session objects
    Bao = Bao;

    /**
     * Dialog for attachment
     */
    DialogAttachment = new BaoDialogViewModel(Bao.Session.ApplicationName);

    /**
     * Access to parent WorkItem (the "parent" for series elements)
     */
    Parent: WorkItem;

    /**
     * Store the info if the WorkItem is a WorkItem Series 
     */
    InitBasedOnSerialTask: KnockoutObservable<boolean> = ko.observable(false);

    // #endregion

    //#region Public Methods

    /**
     * base class abstract method - CustomFilter 
     */
    CustomFilter(): Models.HashObject[] {
        let customFilterHashObject: Models.HashObject[] = [];
        if (this.InitBasedOnSerialTask()) {
            customFilterHashObject.push({
                Key: 'WorkItemId',
                Value: this.Parent.PrimaryWorkItemId()
            });
            customFilterHashObject.push({
                Key: 'BaseOnSerialTask',
                Value: true
            });
        }
        return customFilterHashObject;
    }

    /** 
     *  base class astract method - ItemCompleteCheck
     */
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }

    /** 
     * Custom method for ToolBar Click event
     */
    CustomToolbarClick = (button: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(button.ActionKey);
        switch (key) {
            case WorkItemAttachmentConstants.ADD_WORKITEM_ATTACHMENT_LINK:
                this.Dialog(null,1);
                break;
            case WorkItemAttachmentConstants.EDIT_WORKITEM_ATTACHMENT:
                if (this.Selection() != null) {
                    this.Dialog(this.Selection()[0].WorkItemAttachmentId);
                }
                break;
            case WorkItemAttachmentConstants.DOWNLOAD_WORKITEM_ATTACHMENT:
                if (this.Selection() != null) {
                    this.DownloadWorkItemAttachment(this.Selection()[0].WorkItemAttachmentId);
                }
                break;
        }
    };

    /**
     * Download WorkItemAttachment
     */
    DownloadWorkItemAttachment = (workItemAttachmentId) => {
        BaoRouter.setHash("document/" + workItemAttachmentId);
    }
    
    /**
     * Dialog for Attachment and Link
     */
    Dialog(id: string, documentType : number = 0): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result: Factories.GenericListResponse.DialogResponse) => {

            let vm = ko.map.fromJS(result.Model);
            vm.IsEdit = false;

            if (id != null) {
                documentType = vm.DocumentType();
                vm.IsEdit = true;
            }

            let okButton = null;
            if (documentType == 0) {
                okButton = this.GetOkButtonForFile();

                vm.Upload = () => { };
                vm.SelectedFiles = ko.observableArray<string>();
                vm.DocumentType = ko.observable(0); // sets the document type to file
                vm.SelectedFiles.subscribe((newIds) => {
                    let ids = [vm.WorkItemAttachmentId()];
                    if (newIds != null) {
                        ko.utils.arrayForEach(newIds, (newId, index) => {
                            if (index > 0) {
                                ids.push(guid());
                            }
                        });
                    }
                    vm.DocumentIds(ids);
                });
                vm.DocumentIds = ko.observableArray<string>();
                if (vm.IsEdit) {
                    vm.DocumentIds([id]);
                }
                vm.UploadUrl = ko.computed(() => {
                    let documentIds = vm.DocumentIds().join(";");
                    return WorkItemAttachmentConstants.UPLOAD_DOCUMENT_URL + '?workItemAttachmentIds=' + documentIds;
                });
            }
            else {
                okButton = this.GetOkButtonForLink();

                vm.DocumentType = ko.observable(1); // sets the document type to link
            }

            let cancelButton = new BaoDialogViewModel.ButtonFactory(this.DialogAttachment, Bao.Session.GetMessage("msgCancel"), () => {
                this.DialogAttachment.Close();
            });

            this.DialogAttachment.Width("450px");
            this.DialogAttachment.Buttons([okButton, cancelButton]);

            vm.Parent = this;
            this.DialogAttachment.ViewModel(vm);
            this.DialogAttachment.Template(result.Template);
            this.DialogAttachment.Open(null);
            this.TabPage.IsLoading(false);
        });
    }

    /**
     * Toggle Toolbar Buttons
     */
    ToggleToolbarButtons = () => {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            let enabled = <KnockoutObservable<boolean>>(button.Enabled);
            switch (button.ActionKey()) {
                case WorkItemAttachmentConstants.EDIT_WORKITEM_ATTACHMENT:
                case this.PermissionRemove:
                    enabled(this.Selection() && this.Selection().length == 1);
                    break;
                case WorkItemAttachmentConstants.DOWNLOAD_WORKITEM_ATTACHMENT:
                    enabled(this.Selection() && this.Selection().length > 0 && this.Selection()[0].DocumentType === 0);
                    break;
            }
        });
    }

    /**
     * Init
     */
    init = (): JQueryPromise<void> => {
        if (this.Parent.IsBasedOnVirtual()) {
            this.InitBasedOnSerialTask(true);
        }
        return super.init()
            .always(_ => this.InitBasedOnSerialTask(false));
    }

    // #endregion

    // #region Protected Methods

    /**
     *  Returns ok button for files
     * */
    protected GetOkButtonForFile = () => {
        return new BaoDialogViewModel.ButtonFactory(this.DialogAttachment, this._msgOk, () => {
                if (!Bao.Utils.String.IsNullOrEmpty(this.DialogAttachment.ViewModel().DocumentName())) {
                    this.DialogAttachment.IsLoading(true);
                    let item = this.DialogAttachment.ViewModel();
                    let isEdit = item.IsEdit;
                    $.when(this.DialogAttachment.ViewModel().Upload()).then(() => {
                        let defs = [];
                        ko.utils.arrayForEach(item.DocumentIds(), (id, index) => {
                            let i = ko.map.toJS(item);
                            i.WorkItemAttachmentId = id;
                            i.PrimaryKeyValue = id;
                            i.SimpleSearchId = id;
                            if (isEdit) {
                                i.DocumentName = ko.unwrap(item.DocumentName);
                            }
                            else {
                                i.DocumentName = i.SelectedFiles[index];
                            }
                            defs.push(this.Save(i));
                        });
                        $.when.apply(this, defs).then(() => {
                            this.TabPage.DirtyFlag(true);
                            this.DialogAttachment.IsLoading(false);
                            this.DialogAttachment.Close();
                        });
                    });
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            });
    }

    /**
     * Returns ok button for link
     * */
    protected GetOkButtonForLink = () => {
        return new BaoDialogViewModel.ButtonFactory(this.DialogAttachment, this._msgOk, () => {
            if (!Bao.Utils.String.IsNullOrEmpty(this.DialogAttachment.ViewModel().DocumentName()) &&
                !Bao.Utils.String.IsNullOrEmpty(this.DialogAttachment.ViewModel().Link())) {
                this.DialogAttachment.IsLoading(true);
                let item = this.DialogAttachment.ViewModel();
                let model = ko.map.toJS(item);
                this.Save(model).then(() => {
                    this.TabPage.DirtyFlag(true);
                    this.DialogAttachment.IsLoading(false);
                    this.DialogAttachment.Close();
                });
            } else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            }
        });
    }

    // #endregion
}
export default WorkItemAttachmentTab;